import { Chip, Stack, Typography } from '@mui/material';
import { get } from 'lodash';
import { TypeContributeCompany } from 'src/features/CompanyDetail/Common/config';
import { getContributionTypeLabel } from 'src/features/Contributions/config';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { convertSnakeCaseToUpperFirst, getOriginUrl, renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import {
  IContributeDetailCompany,
  IContributeDetailPeople,
  IContributeDetailReportWrong,
} from 'src/utils/typings/response/contribute';

const GeneralInformation = ({
  dataContribution,
}: {
  dataContribution: IContributeDetailCompany | IContributeDetailPeople | IContributeDetailReportWrong;
}) => {
  const getProfileUrl = () => {
    if (Object.hasOwn(dataContribution, 'company_id'))
      return getOriginUrl() + AuthRouteKeys.CompanyDetail.replace(':id?', get(dataContribution, 'company_id', ''));
    if (Object.hasOwn(dataContribution, 'people_id'))
      return getOriginUrl() + AuthRouteKeys.PeopleDetail.replace(':id?', get(dataContribution, 'people_id', ''));
  };

  return (
    <Stack direction="column" spacing={2} maxWidth="100%">
      <Typography align="left" variant="h6">
        General Information
      </Typography>
      <Stack direction="row" spacing={3}>
        <Stack direction="column" spacing={3}>
          <Stack spacing={1}>
            <Typography align="left" variant="caption2" color="text.secondary">
              Type of Contribution
            </Typography>
            <Typography align="left" variant="body2" color="text.primary">
              {getContributionTypeLabel(
                dataContribution?.type_of_contribution || TypeContributeCompany.ClaimCompanyProfile,
              )}
            </Typography>
          </Stack>
          <Stack spacing={1}>
            <Typography align="left" variant="caption2" color="text.secondary">
              Profile Contribute (URL)
            </Typography>
            <Chip label={getProfileUrl()} color="default" />
          </Stack>
        </Stack>
        <Stack direction="column" spacing={3}>
          <Stack spacing={1}>
            <Typography align="left" variant="caption2" color="text.secondary">
              Company Name
            </Typography>
            <Typography align="left" variant="body2" color="text.primary">
              {renderTextOrDefault(dataContribution?.name)}
            </Typography>
          </Stack>
          <Stack spacing={1}>
            <Typography align="left" variant="caption2" color="text.secondary">
              Relationship to Data
            </Typography>
            <Typography align="left" variant="body2" color="text.primary">
              {convertSnakeCaseToUpperFirst(dataContribution?.relationship_to_data || '')}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default GeneralInformation;
